import React, { useMemo } from 'react'
import { Row, Col, Button } from 'react-angle-dashboard-components'

type IPaginationProps = {
  totalPages: number
  totalItems: number
  currentPage: number
  pageLimit: number
  setPage: Function
}

export const Pagination: React.FC<IPaginationProps> = ({
  totalPages,
  totalItems,
  currentPage,
  setPage,
  pageLimit
}) => {
  const nums = useMemo(
    () =>
      Array(totalPages)
        .fill(1)
        .map((_, i) => i + 1),

    [totalPages]
  )

  const pages = [
    // nums[currentPage - 3],
    nums[currentPage - 2],
    nums[currentPage - 1],
    nums[currentPage],
    nums[currentPage + 1],
    nums[currentPage + 2]
  ].filter(Boolean)

  return (
    <Row className="my-4 mx-0">
      <Col xs="12" className="text-center mx-0 px-0">
        {currentPage > 1 && (
          <Button
            variant="link"
            onClick={() => setPage((s: number) => (s - 1 < 1 ? 1 : s - 1))}
            className={`mr-1 px-1 text-muted`}
          >
            Previous
          </Button>
        )}

        {currentPage - 2 > 1 && (
          <>
            <Button
              variant="link"
              onClick={() => setPage(nums[0])}
              className={`mr-1 px-1 text-muted`}
            >
              {nums[0]}
            </Button>
            ...
          </>
        )}

        {pages.map((e) => (
          <Button
            key={e}
            variant="link"
            onClick={() => setPage(e)}
            className={`mr-1 px-1 ${
              e === currentPage ? 'text-primary' : 'text-muted'
            }`}
          >
            {e}
          </Button>
        ))}

        {currentPage + 3 < totalPages && (
          <>
            ...
            <Button
              variant="link"
              onClick={() => setPage(nums[nums.length - 1])}
              className={`mr-1 px-1 text-muted`}
            >
              {nums[nums.length - 1]}
            </Button>
          </>
        )}

        {currentPage !== totalPages && (
          <Button
            variant="link"
            onClick={() =>
              setPage((s: number) => (s + 1 > totalPages ? totalPages : s + 1))
            }
            className={`px-1 text-muted`}
          >
            Next
          </Button>
        )}
      </Col>
      <Col xs="12" className="text-center">
        <small className="text-muted">
          showing {pageLimit} out of {totalItems} results
        </small>
      </Col>
    </Row>
  )
}
